export const VISIT_LANGUAGE_CODES = ["pl-PL", "en-GB", "uk-UA"] as const;

export type VisitLanguageCode = (typeof VISIT_LANGUAGE_CODES)[number];
export type VisitLanguageValue = VisitLanguageCode | "";

export function isValidVisitLanguage(
  value: unknown,
  allowEmpty = true,
): value is VisitLanguageValue {
  if (typeof value !== "string") {
    return false;
  }

  if (value === "") {
    return allowEmpty;
  }

  return (VISIT_LANGUAGE_CODES as readonly string[]).includes(value);
}

export function normalizeVisitLanguage(
  value: unknown,
  required = false,
): VisitLanguageValue {
  if (isValidVisitLanguage(value, !required)) {
    return value;
  }

  return required ? "pl-PL" : "";
}
